<template>
  <div class="toggle-input">
    <label class="switch">
      <input v-model="innerValue" type="checkbox" class="hidden" :aria-label="ariaLabel" />
      <span class="slider round"></span>
    </label>
  </div>
</template>
<script setup lang="ts">
import { debounce, isEqual } from 'lodash-es';

const props = defineProps({
  modelValue: {
    type: [Boolean, String, Object, Array],
    required: true,
  },
  ariaLabel: {
    type: String,
    default: '',
  },
  trueValue: {
    type: [String, Object, Number, Boolean],
    default: true,
  },
  falseValue: {
    type: [String, Object, Number, Boolean, Array],
    default: false,
  },
});
const emit = defineEmits(['update:modelValue']);
const innerValue = ref<boolean>(isEqual(props.modelValue, props.trueValue));

watch(
  innerValue,
  debounce(newValue => {
    if (newValue) {
      emit('update:modelValue', props.trueValue);
    } else {
      emit('update:modelValue', props.falseValue);
    }
  }, 200),
);

watch(
  () => props.modelValue,
  debounce(newValue => {
    innerValue.value = isEqual(newValue, props.trueValue);
  }, 200),
);
</script>
<style lang="postcss" scoped>
.toggle-input {
  display: flex;
  align-items: center;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}
/* The slider */
.slider {
  @apply border border-primary-A900;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.6s;
}

.slider:before {
  background-color: #a4aac5;
  position: absolute;
  content: '';
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 2px;
  transition: 0.6s;
}

input:checked + .slider {
  background: linear-gradient(271deg, #1363c9 1.12%, #1b2c70 98.82%);
}

input:checked + .slider:before {
  background-color: #cfd1d7;

  transform: translateX(24px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 12px;
}

.slider.round:before {
  border-radius: 50%;
}

input:checked + .slider {
  @apply bg-primary-700;
}
</style>
